import {Icon, TooltipHost} from '@fluentui/react';
import {FC} from 'react';
import styles from './InfoTooltip.module.scss';

export const InfoTooltip: FC<{content: string}> = ({content}) => (
  <TooltipHost content={content}>
    <Icon className={styles.tooltipIcon} iconName="Info" />
  </TooltipHost>
);
